import React from 'react';
import PropTypes from 'prop-types';

const SVG = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" className={props.className}>
    <g fill="none" fillRule="evenodd" stroke="#B5B4B8" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" transform="translate(0 2)">
      <path d="M.5.5h15M.5 4.5h5M.5 8.5h5M.5 12.5h15" />
      <circle cx="11" cy="6" r="2.5" />
      <path d="M12.768 7.768L15 10" />
    </g>
  </svg>
);

SVG.propTypes = {
  className: PropTypes.string,
};

export default SVG;
